import Mutations from '../../odata/mutations';

export default { ...new Mutations('drainedWeight'), ...new Mutations('drainedWeights') };
